import {ValueObject} from '@s-ui/domain'

import {RequestSearchValueObject} from '../ValueObjects/RequestSearchValueObject.js'

export class GetAggregationsRequestSearch extends ValueObject {
  #search
  #aggregations

  constructor({aggregations, search}) {
    super()
    this.#search = search
    this.#aggregations = aggregations
  }

  static createFromSearch({config, listingSectionId, search}) {
    const requestSearchVO = RequestSearchValueObject.createToApi({config, listingSectionId, search})

    return new GetAggregationsRequestSearch({
      search: requestSearchVO,
      // TODO: Remove hardcoded aggregations and create from config
      aggregations: [
        {
          field: 'category1Id',
          name: 'category1Id',
          nestedAggregation: {
            field: 'offerTypeId',
            name: 'offerTypeId'
          }
        }
      ]
    })
  }

  get aggregations() {
    return this.#aggregations
  }

  get search() {
    return this.#search.value
  }

  getRequest() {
    return {
      aggregations: this.aggregations,
      filters: this.#search.getSearchForStockAggregations()
    }
  }

  get value() {
    return {
      search: this.search,
      aggregations: this.aggregations
    }
  }
}
